import React from 'react';
import { FaArrowAltCircleUp, FaWindowClose, FaEnvelope, FaUser, FaRegArrowAltCircleRight } from 'react-icons/fa';

const Newsletter = ({setNavLinks, status1, setStatus1, setisFromContactJs}) => {

  
  const [inputFields, setInputFields] = React.useState({
    name: "",
    email: "",
})

const handleInputChange = (e) =>{

  const {name, value} = e.target
  setInputFields({...inputFields, [name]: value })

}

const handleSubmit = async (e)=> {

  e.preventDefault();
  setStatus1("Subscribing...");

  try{
     const response = await fetch ('https://pgtech.netlify.app/.netlify/functions/api/contactTwo', {

        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(inputFields),
     });


     if (response.ok){
        setStatus1("Subscribe");
        setisFromContactJs(false);
        const result = await response.json();
        alert(result.status);

        setInputFields ({
          name: "",
          email: "",
    
        });
        setNavLinks({successLink: true});
     } else {

        throw new Error ('Failed to send email')}
     } catch (error){

        setStatus1("Subscribe");
        console.error(error);
        alert('An error occurred while sending the mail');
     }
  };

React.useEffect(()=>{

const inputs = document.querySelectorAll("input");


inputs.forEach((entrybox)=>{

  entrybox.addEventListener('blur', (event)=>{

    if(event.target.value){

      entrybox.classList.add("liftLabel");
    }else{

      entrybox.classList.remove("liftLabel");
    };
  });
});



}, []);
  return (
    <div className='container-fluid'> 
             <div className='close-window-icon' ><FaWindowClose color='#1b2328' onClick={()=>{
                  setNavLinks({homeLink: true})
                  sessionStorage.setItem("currentSession", JSON.stringify({homeLink: true}));
                  }}/> </div>
            <h1 className='title'><FaArrowAltCircleUp color='#1b2328' /> Newsletter </h1>


            <form className='form-fields' onSubmit={handleSubmit}>

                  <div className="input-field">
                      <input type="text" required name = "name" value={inputFields.name} onChange={handleInputChange} autoComplete="off"/>
                      <label htmlFor="name"><FaUser/> Name </label>
                  </div>
               
                  <div className="input-field">
                      <input type="email" required name = "email" value={inputFields.email} onChange={handleInputChange} autoComplete="off"/>
                      <label htmlFor="email"><FaEnvelope/> Email Address </label>
                  </div>

                <div className="form-btns">
                  <button className='contact-form-btn  signup-btn'> {status1} <FaRegArrowAltCircleRight/>  </button>
                </div>

            </form>
     
  </div>
  )
}

export default Newsletter;